import { render } from "./404.view.vue?vue&type=template&id=419947cf&scoped=true&ts=true"
import script from "./404.view.vue?vue&type=script&lang=ts"
export * from "./404.view.vue?vue&type=script&lang=ts"

import "./404.view.vue?vue&type=style&index=0&id=419947cf&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419947cf"]])

export default __exports__